import { Controller } from "react-hook-form";
import {
    Select,
    SelectItem,
    Textarea,
    DatePicker,
    NumberInput,
} from "@heroui/react";
import { ThemedText } from "@/components/ui";

const TransferInfoStep = ({
    control,
    errors,
    masterCashes = [],
    watch,
    setValue,
}) => {
    const sourceId = watch("source_master_cash_id");
    const destId = watch("destination_master_cash_id");

    // Filter Logic: Exclude selected Source from Dest options, and vice versa
    const sourceOptions = masterCashes.filter(
        (item) => !destId || String(item.value) !== String(destId),
    );
    const destOptions = masterCashes.filter(
        (item) => !sourceId || String(item.value) !== String(sourceId),
    );

    return (
        <div className="space-y-4">
            <Controller
                name="transaction_date"
                control={control}
                rules={{ required: "Tanggal wajib diisi" }}
                render={({ field }) => (
                    <DatePicker
                        isRequired
                        label="Tanggal Transaksi"
                        variant="bordered"
                        errorMessage={errors.transaction_date?.message}
                        isInvalid={!!errors.transaction_date}
                        value={field.value}
                        onChange={field.onChange}
                        showMonthAndYearPickers
                        hideTimeZone
                        granularity="minute"
                    />
                )}
            />

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <Controller
                    name="source_master_cash_id"
                    control={control}
                    rules={{ required: "Kas Asal wajib dipilih" }}
                    render={({ field }) => (
                        <Select
                            isRequired
                            label="Kas Asal (Sumber)"
                            placeholder="Pilih Kas Asal"
                            variant="bordered"
                            selectedKeys={
                                field.value ? [String(field.value)] : []
                            }
                            onSelectionChange={(keys) =>
                                field.onChange(Array.from(keys)[0])
                            }
                            errorMessage={errors.source_master_cash_id?.message}
                            isInvalid={!!errors.source_master_cash_id}
                        >
                            {sourceOptions.map((item) => (
                                <SelectItem key={item.value}>
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />

                <Controller
                    name="destination_master_cash_id"
                    control={control}
                    rules={{ required: "Kas Tujuan wajib dipilih" }}
                    render={({ field }) => (
                        <Select
                            isRequired
                            label="Kas Tujuan"
                            placeholder="Pilih Kas Tujuan"
                            variant="bordered"
                            selectedKeys={
                                field.value ? [String(field.value)] : []
                            }
                            onSelectionChange={(keys) =>
                                field.onChange(Array.from(keys)[0])
                            }
                            errorMessage={
                                errors.destination_master_cash_id?.message
                            }
                            isInvalid={!!errors.destination_master_cash_id}
                        >
                            {destOptions.map((item) => (
                                <SelectItem key={item.value}>
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />
            </div>

            <Controller
                name="amount"
                control={control}
                rules={{ required: "Nominal wajib diisi" }}
                render={({ field }) => (
                    <NumberInput
                        isRequired
                        label="Nominal Transfer"
                        placeholder="0"
                        variant="bordered"
                        value={field.value || undefined}
                        onValueChange={(val) => {
                            field.onChange(val);
                            if (setValue) setValue("amount", val);
                        }}
                        errorMessage={errors.amount?.message}
                        isInvalid={!!errors.amount}
                        startContent={
                            <ThemedText size="sm" variant="secondary">
                                Rp
                            </ThemedText>
                        }
                        hideStepper
                        formatOptions={{
                            style: "decimal",
                            minimumFractionDigits: 0,
                        }}
                        minValue={0}
                    />
                )}
            />

            <Controller
                name="description"
                control={control}
                render={({ field }) => (
                    <Textarea
                        label="Keterangan"
                        placeholder="Contoh: Topup Saldo Operasional"
                        variant="bordered"
                        value={field.value}
                        onValueChange={field.onChange}
                        errorMessage={errors.description?.message}
                        isInvalid={!!errors.description}
                    />
                )}
            />
        </div>
    );
};

export default TransferInfoStep;
